import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { motion } from "framer-motion";
import { toast } from "react-hot-toast";

const UpdateBatchDialog = ({ open, onClose, onSave, batches, selectedBatchs }) => {
  const [selectedBatch, setSelectedBatch] = useState("");
  const [isMove, setIsMove] = useState(false);
  const [targetBatch, setTargetBatch] = useState("");

  // Preselect old batch if not "All"
  useEffect(() => {
    if (selectedBatchs && selectedBatchs !== "All") {
      setSelectedBatch(selectedBatchs);
    } else {
      setSelectedBatch("");
    }
    setIsMove(false);
    setTargetBatch("");
  }, [selectedBatchs]);

  const handleSave = () => {
    if (!selectedBatch) return;

    if (isMove) {
      if (!targetBatch) {
        toast.error("Please select a target batch.");
        return;
      }
      if (selectedBatch === targetBatch) {
        toast.error("Old batch and new batch cannot be the same!");
        return;
      }
      onSave({ from: selectedBatch, to: targetBatch, isMove: true });
    } else {
      onSave({ batchId: selectedBatch, isMove: false });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperComponent={motion.div}
      PaperProps={{
        initial: { opacity: 1, scale: 0.9, y: -50 },
        animate: { opacity: 1, scale: 1, y: 0 },
        exit: { opacity: 0, scale: 0.95, y: -30 },
        transition: { duration: 0.3, ease: "easeOut" },
        style: { borderRadius: 16, padding: "8px 0", backgroundColor: "#fff" },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          color: "#1976d2",
          textAlign: "center",
          borderBottom: "1px solid #eee",
        }}
      >
        Assign Batch
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        {/* Checkbox for Move Student */}
        <FormControlLabel
          control={
            <Checkbox
              checked={isMove}
              onChange={(e) => setIsMove(e.target.checked)}
              disabled={selectedBatchs === "All"} // Disable if All
            />
          }
          label="Move student to another batch"
        />

        {/* Select Old / Current Batch */}
        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
          <InputLabel>Select Batch</InputLabel>
          <Select
            value={selectedBatch}
            onChange={(e) => setSelectedBatch(e.target.value)}
            label="Select Batch"
          >
            <MenuItem value="">-- Select Batch --</MenuItem>
            {batches.map((batch) => (
              <MenuItem key={batch.id} value={batch.id}>
                {batch.item_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Target Batch dropdown shown only if Move is checked */}
        {isMove && (
          <FormControl fullWidth size="small" sx={{ mt: 2 }}>
            <InputLabel>Select Target Batch</InputLabel>
            <Select
              value={targetBatch}
              onChange={(e) => setTargetBatch(e.target.value)}
              label="Select Target Batch"
            >
              <MenuItem value="">-- Select Target Batch --</MenuItem>
              {batches.map((batch) => (
                <MenuItem key={batch.id} value={batch.id}>
                  {batch.item_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ textTransform: "none", borderRadius: 2, fontWeight: 500 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={!selectedBatch || (isMove && !targetBatch)}
          sx={{ textTransform: "none", borderRadius: 2, fontWeight: 500 }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateBatchDialog;
